import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, tap } from 'rxjs';
import { MetaService } from '../services/meta.service';
import { PageLayoutService } from '../services/page-resolver.service';

export const blogLayoutResolver: ResolveFn<any> = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
): Observable<any> => {
    const pageLayoutService = inject(PageLayoutService);
    const metaService = inject(MetaService);
    return pageLayoutService
        .resolveBlogHomeLayout(route)
        .pipe(tap((response) => metaService.updateMetaTags(response, route)));
};
